import React, { useState, useCallback } from 'react';
import { Box, Button, useMediaQuery } from '@mui/material';
import { artistasData } from './loadArtistasData';
import Artista2026 from './Artista2026';

const Festival2026 = () => {
    const [diaSeleccionadoKey, setDiaSeleccionadoKey] = useState(() => artistasData[0]?.diaKey || null);
    const isMobile = useMediaQuery('(max-width: 600px)');

    // Memoizar el handler de cambio de día
    const handleDiaChange = useCallback((diaKey) => {
        setDiaSeleccionadoKey(diaKey);
    }, []);

    if (!artistasData || artistasData.length === 0) {
        return (
            <Box sx={{
                width: "100%",
                p: "20px",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <p style={{ color: '#fff' }}>No hay artistas disponibles</p>
            </Box>
        );
    }

    return (
        <Box sx={{
            width: "100%",
            p: "10px",
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
        }}>
            {/* Botones de selección de día */}
            <Box sx={{
                display: "flex",
                gap: "10px",
                flexWrap: 'wrap',
            }}>
                {artistasData.map(dia => {
                    const isSelected = diaSeleccionadoKey === dia.diaKey;
                    return (
                        <Button
                            key={dia.diaKey}
                            variant="contained"
                            sx={{
                                backgroundColor: isSelected ? '#D4A646' : 'rgba(255,255,255,0.1)',
                                backdropFilter: 'blur(10px)',
                                color: '#FFFFFF',
                                borderRadius: '8px',
                                height: '50px',
                                flexGrow: 1,
                                fontWeight: 'bold',
                                minWidth: '100px',
                                transition: 'background-color 0.2s ease',
                                '&:hover': {
                                    backgroundColor: isSelected ? '#D4A646' : 'rgba(255,255,255,0.2)',
                                }
                            }}
                            onClick={() => handleDiaChange(dia.diaKey)}
                        >
                            {isMobile ? dia.dia.split(' ')[0].slice(0, 3) + '\n' + dia.dia.split(' ')[1] : dia.dia}
                        </Button>
                    );
                })}
            </Box>

            {/* Lista de Artistas - TODOS se montan, solo se ocultan con display:none */}
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                pt: '20px',
                pb: '20px',
                position: 'relative',
                minHeight:"400px",
            }}>
                {artistasData.map(dia => {
                    const isVisible = diaSeleccionadoKey === dia.diaKey;
                    return (
                        <Box 
                            key={dia.diaKey}
                            sx={{
                                display: isVisible ? 'flex' : 'none',
                                flexWrap: "wrap",
                                justifyContent: "center",
                                alignItems: 'flex-start',
                                boxSizing: 'border-box',
                                py: '20px',
                                width: '100%',
                                px: { xs: '10px', md: '40px', lg: '60px' },
                                gap: { xs: '20px', sm: '30px', md: '40px', lg: '50px' },
                                rowGap: { xs: '30px', sm: '40px', md: '50px' },
                                opacity: isVisible ? 1 : 0,
                                transition: 'opacity 0.3s ease-in-out',
                            }}
                        >
                            {dia.artistas.map(artista => (
                                <Artista2026 
                                    key={artista.id}
                                    artista={artista}
                                />
                            ))}
                        </Box>
                    );
                })}

                {/* Botón de comprar entradas */}
                {/* <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: '30px',
                }}>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            color: '#FFFFFF',
                            borderRadius: '8px',
                            px: '20px',
                            py: '10px',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            backdropFilter: 'blur(10px)',
                            "&:hover": {
                                backgroundColor: '#D4A646',
                            }
                        }}
                        onClick={() => window.location.assign("https://www.edenentradas.ar/event/festival-internacional-de-peas-villa-maria")}
                    >
                        Comprar entradas
                    </Button>
                </Box> */}
            </Box>
        </Box>
    );
};

export default Festival2026;

